module.exports = __webpack_public_path__ + "img/num_9.32e240d9.png";